<template>
  <div class="searchAreaStyle d-flex align-center">
    <div class="titleStyle">{{ $t('order.order_order-product') }}</div>
    <!-- <div class="pl-12 pr-5"> -->
    <div class="pl-12" v-if="!isEdit">
      <NormalButton
        text="order.order_input-from-out-of-stock-products"
        height="32px"
        color="white"
        textColor="thinText--text"
        btnClass="px-3"
        :outlined="true"
        @click="dialogInfo.lackStock = true"
      />
    </div>
    <InputFromLackStockDialog
      v-model="dialogInfo.lackStock"
      @reflect="reflect"
    />

    <NormalTextButton
      v-if="!isEdit"
      :text="`＋ ${$t('order.order_product-registration')}`"
      @click="dialogInfo.register = true"
    />
    <MasterProductDialog
      v-model="dialogInfo.register"
      @success="registerSuccess()"
    />
  </div>
</template>
<script>
import { NormalButton, NormalTextButton } from '@/components/items'
import {
  MasterProductDialog,
  InputFromLackStockDialog
} from '@/components/layouts/Dialogs'

export default {
  components: {
    NormalButton,
    NormalTextButton,
    MasterProductDialog,
    InputFromLackStockDialog
  },
  data: () => ({
    dialogInfo: {
      register: false,
      lackStock: false
    }
  }),
  props: {
    isEdit: { type: Boolean, default: false }
  },
  methods: {
    reflect(...args) {
      this.$emit('lackStockInput', args)
    },
    registerSuccess() {
      this.$emit('productRegisterSuccess')
      this.dialogInfo.register = false
    }
  },
  watch: {}
}
</script>
<style scoped lang="scss">
.titleStyle {
  font-size: 18px;
  font-weight: bold;
}
.searchAreaStyle {
  height: 70px;
}
</style>
